var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center breadcrumb-alt"},_vm._l((_vm.items),function(ref,index){
var label = ref.label;
var icon = ref.icon;
return _c('div',{key:("breadcrumb_item_" + index),staticClass:"d-inline-flex align-items-center breadcrumb-alt-item",class:{
      active: _vm.isActive(index),
      checked: _vm.isChecked(index),
    }},[_c('BtnIcon',_vm._b({nativeOn:{"click":function($event){return _vm.$emit('onclick', index)}}},'BtnIcon',{
        icon: _vm.isChecked(index) ? 'checked' : icon,
        active: _vm.isActive(index),
        iconSize: 16,
      },false)),_c('span',{staticClass:"h-ml-3 h-mr-1"},[_vm._v("\n      "+_vm._s(label)+"\n    ")]),(index + 1 < _vm.items.length)?_c('hr',{staticClass:"align-self-center mx-2 text-muted"}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }